import * as React from "react";
import Activity from "./Activity";
import TitledPanel from "../commons/components/TitledPanel";
import ContactInfoActivity from "../commons/model/activity/ContactInfoActivity";
import "./ActivityTimeline.scss";
import { ActivityTimelineActions } from "../patient-management/ActivityTimelineActions";
import ActivityActionsPanel from "./ActivityActionsPanel";
import { PatientManagementInfo } from "../commons/model/patient/PatientInfo";

interface ActivityTimelineProps {
  activities: ContactInfoActivity[];
  actions: ActivityTimelineActions;
  patient: PatientManagementInfo;
}

export default function ActivityTimeline({ activities, actions, patient }: ActivityTimelineProps) {
  activities = activities.sort(byDate);
  return (
    <div className="activity-timeline">
      <TitledPanel title={i18n["Activity.Timeline.Title"]} withShadow={true} />
      <ActivityActionsPanel actions={actions} patient={patient} />
      {activities.map((it) => (
        <Activity
          key={it.createdAt}
          activity={it}
          fontsUrl={actions.emailAction ? actions.emailAction.fontsUrl : ""}
        />
      ))}
    </div>
  );
}

const byDate = (a1: ContactInfoActivity, a2: ContactInfoActivity) =>
  new Date(a2.createdAt).getTime() - new Date(a1.createdAt).getTime();
